import { Modal, Button } from "react-bootstrap";

interface ConfirmModalProps {
  show: boolean;
  mensaje: string;
  onConfirm: () => void;
  onCancel: () => void;
  variante?: "danger" | "warning";
  titulo?: string;
}

const ConfirmModal = ({
  show,
  mensaje,
  onConfirm,
  onCancel,
  variante = "danger",
  titulo = "Confirmar acción",
}: ConfirmModalProps) => (
  <Modal show={show} onHide={onCancel} centered size="sm">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: "15px" }}>{titulo}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p style={{ margin: 0, fontSize: "14px" }}>{mensaje}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" size="sm" onClick={onCancel}>
        Cancelar
      </Button>
      <Button variant={variante} size="sm" onClick={onConfirm}>
        Confirmar
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmModal;